import $ from 'jquery';
import { gsap, TimelineMax, Power2, Power4, CSSRulePlugin, ScrollTrigger } from 'gsap/all';
require("../__vendor/SplitText.min.js");
gsap.registerPlugin(CSSRulePlugin, ScrollTrigger);
const about_purpose = () => {
$(".tab").on("click", function () {
    if (!$(this).hasClass("active")) {
        let clickedIndex = $(this).index();
        $(".tab.active").removeClass("active");
        $(this).addClass("active");
        $(".tab--content.active").fadeOut(0).removeClass("active");
        $(".tab--content").eq(clickedIndex).fadeIn().addClass("active");
    } else {
    }
});
}
export default about_purpose;





